/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteReversingFailedDtoBase
 * auto generated base class for the model RouteReversingFailedDtoModel.
 *
 * Route reversing failed event
 */
export const RouteReversingFailedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteReversingFailedDto')
  .props({
    __typename: types.optional(types.literal("RouteReversingFailedDto"), "RouteReversingFailedDto"),
    /** Payload of route reversing failed */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteReversingFailedDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteReversingFailedDto() {
  return new RouteReversingFailedDtoModelSelector()
}

export const routeReversingFailedDtoModelPrimitives = selectFromRouteReversingFailedDto()
